import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CostTableComponent } from './cost-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [CostTableComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports: [CostTableComponent],
  entryComponents: [CostTableComponent],
})
export class CostTableModule { }
